package com.eladfinish.bible.contest.screens.chapterComplete.usecases

import com.eladfinish.bible.contest.common.usecases.RemoveNikudAndTeamimAndMakafUseCase
import com.eladfinish.bible.contest.data.VerseEntity

class SortVersesLexicographicallyUseCase(
    private val removeNikudAndTeamimAndMakafUseCase: RemoveNikudAndTeamimAndMakafUseCase,
) {

    operator fun invoke(versesList: List<VerseEntity>): List<VerseEntity> {
        val comparator = Comparator { verse1: VerseEntity, verse2: VerseEntity ->
            val text1: String = removeNikudAndTeamimAndMakafUseCase(verse1.strPasuk)
            val text2: String = removeNikudAndTeamimAndMakafUseCase(verse2.strPasuk)
            text1.compareTo(text2)
        }

        return versesList.toMutableList().apply {
            sortWith(comparator)
        }
    }

}
